__turbopack_context__.v({
  "accordion": "SIWOva_accordion",
  "activeTopic": "SIWOva_activeTopic",
  "contact": "SIWOva_contact",
  "contactEyebrow": "SIWOva_contactEyebrow",
  "eyebrow": "SIWOva_eyebrow",
  "faqBody": "SIWOva_faqBody",
  "hero": "SIWOva_hero",
  "heroDescription": "SIWOva_heroDescription",
  "heroInner": "SIWOva_heroInner",
  "heroTitle": "SIWOva_heroTitle",
  "noResults": "SIWOva_noResults",
  "page": "SIWOva_page",
  "results": "SIWOva_results",
  "resultsHeader": "SIWOva_resultsHeader",
  "search": "SIWOva_search",
  "srOnly": "SIWOva_srOnly",
  "toggle": "SIWOva_toggle",
  "topicRail": "SIWOva_topicRail",
  "topicScroller": "SIWOva_topicScroller",
});
